import { ProductSliderProps } from "@omni/types/components/props/productSlider.props";

import { ProductSliderDefault } from "@/components/Product/ProductSlider/productSlider.default";

type RelatedProductsProps = {
    productSliderProps: ProductSliderProps;
};

export const RelatedProducts = ({
    productSliderProps
}: RelatedProductsProps) => {
    return (
        <>
            <hr />
            <ProductSliderDefault {...productSliderProps} />
        </>
    );
};
